import { black50, blue, green, greenHover, grey6, blueWash, gray10 } from './colors.js';
const deprecatedColors = {
  // Colors under this line should be removed
  // Do not add more colors to this file.
  black50: black50,
  linkBlue: blue,
  vibrantBlue: '#0152c3',
  lightSkyBlue: '#B0CAFF',
  // Greens
  positiveGreen: green,
  positiveGreenHover: greenHover,
  // Very light greys
  superLightGrey: '#f5f6f8',
  lightGrey: '#f7f8fa',
  midLightGrey: grey6,
  // Blue greys from light to dark
  superLightBlueGrey: blueWash,
  whiteBlueGrey: gray10,
  // palette.backgroundAlternate
  // AKA slateLight
  lightBlueGrey: '#90a1b8',
  midGrey: '#9da6b1',
  middleDarkBlueGrey: '#5f7285',
  midDarkBlueGrey: '#4e5c68',
  darkBlueGrey: '#202a36',
  // Ocean blues
  oceanBlue: '#0f3256',
  oceanBlueGrey: '#113355',
  deepOceanBlue: '#002f6b',
  darkOceanBlue: '#043169',
  midOceanBlue: '#0b3466'
};
export { deprecatedColors as default };
//# sourceMappingURL=deprecatedColors.js.map
